import React, { FC } from "react";
import { Station } from "@shared/models";

import "./index.scss";

interface StationsPreviewProps {
  stations: Station[];
}

const StationsPreview: FC<StationsPreviewProps> = ({ stations }) => {
  return (
    <div className="stations-preview">
      {stations.length ? (
        stations.map((s) => (
          <div className="station-preview-item" key={s.id}>
            <div className="station-code">{s.station_code}</div>
          </div>
        ))
      ) : (
        <div>No SDH Assigned</div>
      )}
    </div>
  );
};

export default StationsPreview;
